import { useAuthUserQuery, useMounted } from "@/hooks";
import routes from "@/lib/routes";
import { useEffect, useState } from "react";

export function useRequireLogout() {
  const [result, setResult] = useState(false);

  const mounted = useMounted();
  const { data, loading } = useAuthUserQuery({
    onError: () => {
      window.location.replace(routes.home);
    },
  });
  useEffect(() => {
    if (mounted && !loading && data?.user) {
      window.location.replace(routes.home);
    } else {
      setResult(true);
    }
  }, [mounted, loading, data?.user]);

  return result;
}
